import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { AppSettings, Unit4Env } from '@klingerator/shared';
import { api } from '@/services/api';

/** Instellingen + Unit4-omgeving (uit /health) — user ziet subset, admin alles. */
export const useSettingsStore = defineStore('settings', () => {
  const settings = ref<Partial<AppSettings>>({});
  const unit4Env = ref<Unit4Env | null>(null);
  const loaded = ref(false);

  async function load(force = false) {
    if (loaded.value && !force) return;
    try {
      const [{ data: s }, { data: h }] = await Promise.all([
        api.get<Partial<AppSettings>>('/settings', { silent: true, noToast: true }),
        api.get<{ unit4Env: Unit4Env }>('/health', { silent: true, noToast: true }),
      ]);
      settings.value = s;
      unit4Env.value = h.unit4Env;
      loaded.value = true;
    } catch {
      /* stil — navbar toont dan geen env-badge */
    }
  }

  async function save(patch: Partial<AppSettings>) {
    const { data } = await api.put<AppSettings>('/settings', patch);
    settings.value = data;
    return data;
  }

  return { settings, unit4Env, loaded, load, save };
});
